<div class="blank-layout-container">
    <router-outlet></router-outlet>
</div>